import React from 'react';

import { LabelInput } from '@/components/ui/inputs';
import { SidePanelFormLayout } from '@/components/layout';
import { CollapsibleSection } from '@/components/ui/panels';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';
import { useTranslation } from '@/i18n';
import type { RoleAssignedEmployee } from '@/api/domains/authorization';


interface EmployeeRolesDetailPanelProps {
  employee: RoleAssignedEmployee;
}

export const EmployeeRolesDetailPanel: React.FC<EmployeeRolesDetailPanelProps> = ({
  employee,
}) => {
  const { t: translate } = useTranslation();

  return (
    <SidePanelFormLayout>
      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('authorization:assigned.detail.rut')}
          value={employee.rut}
          disabled
          readOnly
          data-testid="employee-roles-detail-rut"
        />
        <LabelInput
          label={translate('authorization:assigned.detail.name')}
          value={employee.name}
          disabled
          readOnly
          data-testid="employee-roles-detail-name"
        />
        <LabelInput
          label={translate('authorization:assigned.detail.status')}
          value={translate(`authorization:assigned.status.${employee.status}`)}
          disabled
          readOnly
          data-testid="employee-roles-detail-status"
        />
      </SidePanelFormLayout.Fields>

      <CollapsibleSection
        title={translate('authorization:assigned.detail.webRoles')}
        count={employee.webRolesCount}
        variant="filled"
        defaultExpanded
      >
        <ul className="flex flex-col gap-3 px-3 pt-3 pb-2">
          {employee.webRoleNames.map((roleName) => (
            <li key={roleName}>
              <Text variant="subheader-regular" color={colors.grays.neutral66}>{roleName}</Text>
            </li>
          ))}
        </ul>
      </CollapsibleSection>

      <CollapsibleSection
        title={translate('authorization:assigned.detail.mobileRoles')}
        count={employee.mobileRolesCount}
        variant="filled"
        defaultExpanded
      >
        <ul className="flex flex-col gap-3 px-3 pt-3 pb-2">
          {employee.mobileRoleNames.map((roleName) => (
            <li key={roleName}>
              <Text variant="subheader-regular" color={colors.grays.neutral66}>{roleName}</Text>
            </li>
          ))}
        </ul>
      </CollapsibleSection>
    </SidePanelFormLayout>
  );
};

export default EmployeeRolesDetailPanel;
